"use client";

import { useUserSessionCleanup } from "./hooks/useUserSessionCleanup";

export const ClientEffects = () => {
  useUserSessionCleanup();

  return null;
};
